import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';
import { useChatStore } from '../store/chatStore';

const variants = {
  hidden: { backgroundColor: 'rgba(0, 0, 0, 0)' },
  visible: { backgroundColor: 'rgba(0, 0, 0, 0.2)' },
};

const FullscreenImage = () => {
  const { fullScreenImage, setFullScreenImage } = useChatStore();

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setFullScreenImage(null);
  };

  const handleImageClick = (e: React.MouseEvent<HTMLImageElement>) => {
    e.stopPropagation();
  };

  if (!fullScreenImage) return null;

  return (
    <motion.div
      onClick={handleClick}
      className={cn(
        'pointer-events-auto absolute inset-0 z-50 flex h-full w-full items-center justify-center rounded-md px-4'
      )}
      variants={variants}
      transition={{ duration: 0.3 }}
      initial="hidden"
      animate="visible"
      exit="hidden"
    >
      <motion.img
        layoutId={fullScreenImage.key}
        src={fullScreenImage.image}
        alt="Fullscreen Image"
        onClick={handleImageClick}
        className="h-auto max-h-[90%] w-auto max-w-full cursor-zoom-out rounded-xl object-contain"
        transition={{ duration: 0.3 }}
      />
    </motion.div>
  );
};

export default FullscreenImage;
